/* Mile & Kin — Commerce Homepage v1. Minimal vanilla JS: no build step, no dependencies.
   Handles: search overlay, cart drawer, mobile menu, shared scrim, Esc-to-close. */
(function () {
  'use strict';

  var scrim = document.querySelector('[data-mk-scrim]');
  var overlays = {
    search: document.querySelector('[data-mk-search]'),
    cart: document.querySelector('[data-mk-cart]'),
    menu: document.querySelector('[data-mk-menu]')
  };
  var openers = document.querySelectorAll('[data-mk-open]');
  var closers = document.querySelectorAll('[data-mk-close]');
  var current = null;

  function open(name) {
    var el = overlays[name];
    if (!el) return;
    close();
    el.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    current = name;
    var focusable = el.querySelector('input, button, a');
    if (focusable) focusable.focus();
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!current) return;
    var el = overlays[current];
    if (el) el.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    current = null;
    document.body.style.overflow = '';
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-mk-open');
      if (current === target) { close(); } else { open(target); }
    });
  });
  closers.forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* Keep the cart badge in sync after any /cart/add or /cart/change AJAX call
     elsewhere on the theme (native product forms use standard Shopify endpoints). */
  document.addEventListener('mk:cart:refresh', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-mk-cart-count]');
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  });
})();
